export default __webpack_public_path__ + "static/media/banner2.95f03c9e.jpg";